const TextareaMaterial = (props) => {
	return (
		<div className="pd-material__group">
			<textarea
				className="pd-material__input pd-material__input__textarea"
				type="textarea"
				rows={props.rows}
				required={props.required}
				name={props.name}
				value={props.value}
				placeholder={props.placeholder}
				id={props.name}
				onChange={props.onChange}
				onFocus={props.onFocus}
				onKeyPress={props.onKeyPress}
			></textarea>
			<label className="pd-material__input__label" htmlFor={props.name}>
				{props.children}
			</label>
		</div>
	);
};

export default TextareaMaterial;
